import { Star } from "lucide-react";
import UserChip from "../common/UserChip";
import { CATEGORY_LABELS } from "../../lib/constants";

export default function HistoryCard({ item, onClick }) {
  const { rating, cp } = item;
  const category = cp?.post?.category;

  return (
    <div
      onClick={onClick}
      className="p-4 bg-white rounded-lg border border-stone/40 shadow-card hover:shadow-card-hover cursor-pointer transition-shadow"
    >
      {/* Top row: rater or post title + stars + CP */}
      <div className="flex items-center justify-between mb-2">
        <div className="min-w-0 flex-1">
          {rating?.rater ? (
            <UserChip user={rating.rater} link={false} />
          ) : (
            <span className="font-medium text-walnut text-sm truncate">
              {cp?.post?.title || "Community Points"}
            </span>
          )}
        </div>
        <div className="flex items-center gap-2 shrink-0 ml-2">
          {cp && (
            <span className="text-xs font-semibold text-white bg-sage px-2 py-0.5 rounded-full">
              +{cp.points} CP
            </span>
          )}
          {rating && (
            <div className="flex gap-0.5">
              {[1, 2, 3, 4, 5].map((s) => (
                <Star
                  key={s}
                  size={14}
                  className={s <= rating.stars ? "fill-amber text-amber" : "text-stone"}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Feedback or post title */}
      {rating?.feedback && (
        <p className="text-sm text-walnut leading-relaxed line-clamp-2">{rating.feedback}</p>
      )}
      {!rating && cp?.post?.title && (
        <p className="text-sm text-walnut leading-relaxed line-clamp-1">{cp.post.title}</p>
      )}

      {/* Category + date */}
      <div className="flex items-center gap-2 mt-2">
        {category && (
          <span className="text-xs text-terracotta bg-terracotta/10 px-1.5 py-0.5 rounded">
            {CATEGORY_LABELS[category]}
          </span>
        )}
        <span className="text-xs text-walnut-light/60">
          {new Date(item.created_at).toLocaleDateString()}
        </span>
      </div>
    </div>
  );
}
